export type Breakpoint = keyof typeof BREAKPOINT;
export const BREAKPOINT = {
    phone: 360,
    tablet: 600,
    desktop: 1024,
    large_desktop: 1400,
} as const;

export type BreakpointRange = keyof typeof BREAKPOINT_RANGE;
export const BREAKPOINT_RANGE = {
    small_phone: {
        min: 0,
        max: BREAKPOINT.phone - 1,
    },
    phone: {
        min: BREAKPOINT.phone,
        max: BREAKPOINT.tablet - 1,
    },
    tablet: {
        min: BREAKPOINT.tablet,
        max: BREAKPOINT.desktop - 1,
    },
    desktop: {
        min: BREAKPOINT.desktop,
        max: BREAKPOINT.large_desktop - 1,
    },
    large_desktop: {
        min: BREAKPOINT.large_desktop,
        max: 2 ** 31 - 2,
    },
} as const;

export type MediaQuery = keyof typeof MEDIA_QUERY;
export const MEDIA_QUERY = {
    'up-to-extra-small': `@media screen and (max-width: ${BREAKPOINT_RANGE.small_phone.max}px)`,

    'from-small': `@media screen and (min-width: ${BREAKPOINT_RANGE.phone.min}px)`,
    'small-only': `@media screen and (min-width: ${BREAKPOINT_RANGE.phone.min}px) and (max-width: ${BREAKPOINT_RANGE.phone.max}px)`,
    'up-to-small': `@media screen and (max-width: ${BREAKPOINT_RANGE.phone.max}px)`,

    'from-medium': `@media screen and (min-width: ${BREAKPOINT_RANGE.tablet.min}px)`,
    'medium-only': `@media screen and (min-width: ${BREAKPOINT_RANGE.tablet.min}px) and (max-width: ${BREAKPOINT_RANGE.tablet.max}px)`,
    'up-to-medium': `@media screen and (max-width: ${BREAKPOINT_RANGE.tablet.max}px)`,

    'from-large': `@media screen and (min-width: ${BREAKPOINT_RANGE.desktop.min}px)`,
    'large-only': `@media screen and (min-width: ${BREAKPOINT_RANGE.desktop.min}px) and (max-width: ${BREAKPOINT_RANGE.desktop.max}px)`,
    'up-to-large': `@media screen and (max-width: ${BREAKPOINT_RANGE.desktop.max}px)`,

    'from-extra-large': `@media screen and (min-width: ${BREAKPOINT_RANGE.large_desktop.min}px)`,
    'up-to-extra-large': `@media screen and (max-width: ${BREAKPOINT_RANGE.large_desktop.max}px)`,
    print: '@media print',
};
